(() => {
  const money = cents => new Intl.NumberFormat('es-CL', {style:'currency',currency:'CLP',maximumFractionDigits:0}).format(cents / 100);
  function initialize(root = document) {
    root.querySelectorAll('[data-mb-product]').forEach(section => {
      if (section.dataset.initialized) return;
      section.dataset.initialized = 'true';
      const form = section.querySelector('form');
      const variants = JSON.parse(section.querySelector('[data-mb-variants]').textContent);
      function sync() {
        const radio = section.querySelector('[name="mb-variant"]:checked');
        if (!radio) return;
        const variant = variants.find(v => String(v.id) === radio.dataset.variantId);
        if (!variant) return;
        form.querySelector('[name="id"]').value = variant.id;
        const label = 'Comprar ' + radio.dataset.label + ' · ' + money(variant.price);
        section.querySelectorAll('[data-mb-buy-label]').forEach(el => el.textContent = variant.available ? label : 'Agotado');
        section.querySelectorAll('[name="add"], [data-action-atc]').forEach(button => button.disabled = !variant.available);
        const url = new URL(location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState(history.state, '', url);
      }
      section.addEventListener('change', event => {if (event.target.matches('[name="mb-variant"]')) sync();});
      const mediaButtons = [...section.querySelectorAll('[data-mb-image], [data-mb-video]')];
      mediaButtons.forEach(button => button.addEventListener('click', () => {
        const image = section.querySelector('.mb-product-image');
        const galleryVideo = section.querySelector('[data-mb-gallery-video]');
        const isVideo = button.hasAttribute('data-mb-video');
        image.hidden = isVideo;
        if (galleryVideo) {
          galleryVideo.hidden = !isVideo;
          if (!isVideo) galleryVideo.querySelector('video')?.pause();
        }
        section.querySelectorAll('[data-mb-image], [data-mb-video]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        if (isVideo) return;
        image.removeAttribute('srcset'); image.src = button.dataset.mbImage;
        image.alt = button.dataset.mbAlt || button.querySelector('img')?.alt || '';
        image.classList.toggle('mb-product-image--step', button.dataset.mbStep === 'true');
      }));
      const swipeImage = section.querySelector('.mb-product-image');
      if (swipeImage && mediaButtons.length > 1) {
        let start = null;
        swipeImage.addEventListener('dragstart', event => event.preventDefault());
        swipeImage.addEventListener('pointerdown', event => {
          if (!event.isPrimary || event.button !== 0) return;
          start = {x: event.clientX, y: event.clientY, id: event.pointerId};
          swipeImage.setPointerCapture(event.pointerId);
        });
        swipeImage.addEventListener('pointercancel', () => { start = null; });
        swipeImage.addEventListener('pointerup', event => {
          if (!start || start.id !== event.pointerId) return;
          const dx = event.clientX - start.x;
          const dy = event.clientY - start.y;
          start = null;
          if (Math.abs(dx) < 48 || Math.abs(dx) < Math.abs(dy) * 1.3) return;
          const current = mediaButtons.findIndex(button => button.getAttribute('aria-pressed') === 'true');
          const next = Math.max(0, Math.min(mediaButtons.length - 1, current + (dx < 0 ? 1 : -1)));
          if (next !== current) mediaButtons[next].click();
        });
      }
      section.syncMbSelection = sync;
      sync();
      const primaryBuy = section.querySelector('.mb-buy-row');
      const sticky = section.querySelector('[data-mb-pdp-sticky]');
      if (primaryBuy && sticky) {
        const syncSticky = () => { sticky.hidden = primaryBuy.getBoundingClientRect().bottom > 0; };
        section.syncMbSticky = syncSticky;
        if ('IntersectionObserver' in window) {
          const observer = new IntersectionObserver(syncSticky, {threshold: 0});
          observer.observe(primaryBuy);
        } else {
          window.addEventListener('scroll', syncSticky, {passive: true});
        }
        syncSticky();
      }
    });
    root.querySelectorAll('[data-mb-home]').forEach(section => {
      if (section.dataset.initialized) return;
      section.dataset.initialized = 'true';
      const sync = () => {
        const radio = section.querySelector('[name="mb-pack"]:checked');
        const link = section.querySelector('#mb-sticky-btn');
        if (radio && link) {link.textContent = 'Comprar ' + radio.value + ' · ' + radio.dataset.price; link.href = radio.dataset.url;}
      };
      section.addEventListener('change', sync); sync();
      const heroCta = section.querySelector('[data-memo-cta="home_hero"]');
      const sticky = section.querySelector('[data-mb-home-sticky]');
      if (heroCta && sticky) {
        const syncSticky = () => { sticky.hidden = heroCta.getBoundingClientRect().bottom > 0; };
        section.syncMbSticky = syncSticky;
        if ('IntersectionObserver' in window) {
          const observer = new IntersectionObserver(syncSticky, {threshold: 0});
          observer.observe(heroCta);
        } else {
          window.addEventListener('scroll', syncSticky, {passive: true});
        }
        syncSticky();
      }
    });
  }
  function closeMenus(event) {
    document.querySelectorAll('.mb-mobile-menu[open]').forEach(menu => {
      if (event.type === 'keydown') {
        if (event.key !== 'Escape') return;
        menu.open = false;
        menu.querySelector('summary')?.focus();
      } else if (!menu.contains(event.target) || event.target.closest('nav a')) {
        menu.open = false;
      }
    });
  }
  document.addEventListener('click', closeMenus);
  document.addEventListener('keydown', closeMenus);
  document.addEventListener('DOMContentLoaded', () => initialize());
  document.addEventListener('shopify:section:load', e => initialize(e.target));
  window.addEventListener('pageshow', () => {
    document.querySelectorAll('.mb-mobile-menu[open]').forEach(menu => { menu.open = false; });
    initialize();
    document.querySelectorAll('[data-mb-product]').forEach(section => { section.syncMbSelection?.(); section.syncMbSticky?.(); });
    document.querySelectorAll('[data-mb-home]').forEach(section => section.syncMbSticky?.());
  });
})();
